







































































import { Vue, Component, Prop } from "vue-property-decorator";
import TotalPopulationData from "@/components/Detail/TotalData.vue";
import { currentScoutingStore } from "@/store/typed";
import PopulationsTab from "@/components/Detail/PopulationsTab.vue";
import MediaTab from "@/components/Detail/MediaTab.vue";
import VContentLoading from "@/components/VContentLoading.vue";

// FIXME: Logic duplicated from ScoutingDetails
@Component({
  components: {
    TotalPopulationData,
    PopulationsTab,
    MediaTab,
    VContentLoading,
  },
})
export default class ScoutingDetails extends Vue {
  private isOpen = true;
  private selected = "population";
  private population = 0;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  get scoutingArea() {
    return currentScoutingStore.scoutingAreas.find(
      (e) => e.id === this.$route.params.id
    );
  }

  get isMedia() {
    return this.selected === "media";
  }

  get isPopulation() {
    return this.selected === "population";
  }

  get areaIds() {
    return [this.scoutingArea?.id];
  }

  onPopulationChanged(value: number) {
    this.population = value;
  }
}
